import React from 'react';

import { Empty } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

interface ReportDivisionAccessGateProps {
  children: React.ReactNode;
  canQuery: boolean;
  permissionsLoaded: boolean;
}

/**
 * Report content, or a notice when none of the selected divisions grants report read access.
 * The report hooks skip the query in that case, so without this the previous selection's
 * data would stay on screen.
 */
const ReportDivisionAccessGate: React.FC<ReportDivisionAccessGateProps> = ({
  children,
  canQuery,
  permissionsLoaded,
}) => {
  if (permissionsLoaded && !canQuery) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<IntlMessages id="dashboards.report.noDivisionAccess" />}
      />
    );
  }

  return <>{children}</>;
};

export default React.memo(ReportDivisionAccessGate);
